function initCancelBtns() {
    var cancelBtns = document.querySelectorAll('.jsCancelOrder');
    for (var i = 0; i < cancelBtns.length; i++) {
        cancelBtns[i].onclick = cancelOrder;
    }
}

function cancelOrder(event) {
    event.preventDefault();

    var el = this;

    var cancelConfirmText = el.getAttribute('data-confirm-text');

    if (!confirm(cancelConfirmText)) {
        return;
    }

    var form = el.closest("form");
    var number = el.getAttribute('data-order-number');
    var language = el.getAttribute('data-language');
    var securityString = el.getAttribute('data-securitystring');

    var data = {
        orderNumber: number,
        language: language,
        securityString: securityString
    };

    fetch(form.action, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(function (result) {
            return result.text();
        })
        .then(function () {

            var canceledOrderStatus = el.getAttribute('data-cancelled-order-status');

            let cancelforms = document.querySelectorAll(".cancel-order-form-" + number);
            for (const element of cancelforms) {
                element.remove();
            }

            let progressbars = document.querySelectorAll(".js-order-progressbar-" + number);
            for (const element of progressbars) {
                var progressbar = element;

                var steppers = progressbar.querySelectorAll('.stepper-item');
                var truckElement = null;

                for (var i = 0; i < steppers.length; i++) {
                    if (!steppers[i].classList.contains("completed")) {

                        // Get the status name
                        var stepname = steppers[i].querySelector('.step-name').innerText;

                        if (steppers[i].classList.contains("active")) {
                            // Remove active class
                            steppers[i].classList.remove("active");

                            // Get the truck icon 
                            truckElement = steppers[i].querySelector('.step-truck');
                        }

                        if (stepname != canceledOrderStatus) {
                            steppers[i].classList.add("completed");
                        }

                        if (stepname == canceledOrderStatus) {
                            steppers[i].classList.add("active");
                            steppers[i].appendChild(truckElement);

                            break;
                        }
                    }
                }
            }
        })
        .catch(function (err) {
            console.log(err);
        });
}

initCancelBtns();